import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_CLIENTS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchClients = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_CLIENTS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/clients",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
